var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26367 14C1.85117 14 1.49805 13.8531 1.2043 13.5594C0.910547 13.2656 0.763672 12.9125 0.763672 12.5V1.5C0.763672 1.0875 0.910547 0.734376 1.2043 0.440626C1.49805 0.146876 1.85117 0 2.26367 0H7.76367V1.5H2.26367V12.5H7.76367V14H2.26367Z",
    fill: "#DADADC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76367 7.328L12.5801 7.328L12.5801 6L5.76367 6L5.76367 7.328Z",
    fill: "#DADADC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6683 10.056L13.6763 7.048C13.9723 6.744 13.9723 6.256 13.6763 5.96L10.6763 2.952L10.7963 2.8C10.9963 2.544 11.2123 2.32 11.4683 2.12L11.6203 2L14.6283 5.008C14.9963 5.376 15.1963 5.856 15.2363 6.344L15.2363 6.648C15.1963 7.136 14.9963 7.608 14.6283 7.992L11.6203 11L11.4683 10.88C11.2283 10.68 10.9963 10.456 10.7963 10.208L10.6763 10.056L10.6683 10.056Z",
    fill: "#DADADC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.5e0b31ec13b476764a2bf30cb4379733.svg";
export { ForwardRef as ReactComponent };